var _path, _path2, _path3, _path4, _rect, _rect2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseSvg = function SvgHouseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 340"
  }, props), "{/* Roof outline */}", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2d8a2d",
    d: "M10 180 110 30l100 150"
  })), "{/* Left wall */}", _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d8a2d",
    d: "M10 180v150"
  })), "{/* Right wall \u2014 stops at window level */}", _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d8a2d",
    d: "M210 180v150"
  })), "{/* Bottom wall */}", _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d8a2d",
    d: "M10 330h200"
  })), "{/* Door \u2014 centered at x=110, width=50 \u2192 x=85 */}", _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 80,
    x: 85,
    y: 250,
    fill: "none",
    stroke: "#2d8a2d",
    rx: 4
  })), "{/* Window \u2014 centered at x=110, width=70 \u2192 x=75; above door */}", _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 52,
    x: 75,
    y: 170,
    fill: "#2d8a2d",
    rx: 4
  })), "{/* Cross dividers */}", _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M75 196h70M110 170v52"
  })));
};
export { SvgHouseSvg as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogICAgICAgIHZpZXdCb3g9IjAgMCAyMjAgMzQwIgogICAgICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgICAgICA+CiAgICAgICAgey8qIFJvb2Ygb3V0bGluZSAqL30KPHBvbHlsaW5lCnBvaW50cz0iMTAsMTgwIDExMCwzMCAyMTAsMTgwIgpmaWxsPSJub25lIgpzdHJva2U9IiMyZDhhMmQiCnN0cm9rZVdpZHRoPSIxMiIKc3Ryb2tlTGluZWpvaW49InJvdW5kIgpzdHJva2VMaW5lY2FwPSJyb3VuZCIKLz4KICAgICAgICB7LyogTGVmdCB3YWxsICovfQo8bGluZQp4MT0iMTAiIHkxPSIxODAiIHgyPSIxMCIgeTI9IjMzMCIKc3Ryb2tlPSIjMmQ4YTJkIiBzdHJva2VXaWR0aD0iMTIiIHN0cm9rZUxpbmVjYXA9InJvdW5kIgovPgogICAgICAgIHsvKiBSaWdodCB3YWxsIOKAlCBzdG9wcyBhdCB3aW5kb3cgbGV2ZWwgKi99CjxsaW5lCngxPSIyMTAiIHkxPSIxODAiIHgyPSIyMTAiIHkyPSIzMzAiCnN0cm9rZT0iIzJkOGEyZCIgc3Ryb2tlV2lkdGg9IjEyIiBzdHJva2VMaW5lY2FwPSJyb3VuZCIKLz4KICAgICAgICB7LyogQm90dG9tIHdhbGwgKi99CjxsaW5lCngxPSIxMCIgeTE9IjMzMCIgeDI9IjIxMCIgeTI9IjMzMCIKc3Ryb2tlPSIjMmQ4YTJkIiBzdHJva2VXaWR0aD0iMTIiIHN0cm9rZUxpbmVjYXA9InJvdW5kIgovPgogICAgICAgIHsvKiBEb29yIOKAlCBjZW50ZXJlZCBhdCB4PTExMCwgd2lkdGg9NTAg4oaSIHg9ODUgKi99CjxyZWN0IHg9Ijg1IiB5PSIyNTAiIHdpZHRoPSI1MCIgaGVpZ2h0PSI4MCIgcng9IjQiCiAgICAgIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzJkOGEyZCIgc3Ryb2tlV2lkdGg9IjgiIC8+CiAgICAgICAgey8qIFdpbmRvdyDigJQgY2VudGVyZWQgYXQgeD0xMTAsIHdpZHRoPTcwIOKGkiB4PTc1OyBhYm92ZSBkb29yICovfQo8cmVjdCB4PSI3NSIgeT0iMTcwIiB3aWR0aD0iNzAiIGhlaWdodD0iNTIiIHJ4PSI0IgogICAgICBmaWxsPSIjMmQ4YTJkIiAvPgogICAgICAgIHsvKiBDcm9zcyBkaXZpZGVycyAqL30KPGxpbmUgeDE9Ijc1IiB5MT0iMTk2IiB4Mj0iMTQ1IiB5Mj0iMTk2IiBzdHJva2U9IndoaXRlIiBzdHJva2VXaWR0aD0iNCIgLz4KPGxpbmUgeDE9IjExMCIgeTE9IjE3MCIgeDI9IjExMCIgeTI9IjIyMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlV2lkdGg9IjQiIC8+CiAgICAgICAgPC9zdmc+Cg==";